<template>
  <BreadCrumb PageTitle="Liste des vérifications" />
  <ListeVerification />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeVerification from "../../components/Verification/ListeVerification.vue";

export default defineComponent({
  name: "ListeVerificationPage",
  components: {
    BreadCrumb,
    ListeVerification,
  },
});
</script>
